"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerController = void 0;
var csod = require("player-core");
var SpinnerController = (function () {
    function SpinnerController() {
    }
    SpinnerController.on = function (forceRender) {
        if (forceRender === void 0) { forceRender = false; }
        csod.viewModel.isLoading = true;
        forceRender && csod.engine.commit();
    };
    SpinnerController.off = function (forceRender) {
        if (forceRender === void 0) { forceRender = false; }
        csod.viewModel.isLoading = false;
        forceRender && csod.engine.commit();
    };
    return SpinnerController;
}());
exports.SpinnerController = SpinnerController;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/SpinnerController.ts
// module id = 154
// module chunks = 0 2